import { z } from 'zod';

export const ExtensibleFieldsSchema = z.record(z.string(), z.unknown());
export type ExtensibleFields = z.infer<typeof ExtensibleFieldsSchema>;
